export default "__VITE_ASSET__Dqw9wuvs__"